import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import BorderedComponent from '../common/containers/BorderedContainer';
import DisplayText from '../common/text/DisplayText';
import { safeExtractFromObject } from '../helpers/helpers';

import Colors from '../constants/Colors';

export default function CompanySettingsCard({
  title,
  children,
  style = {},
  leftHeaderView,
  onRef,
  containerStyle = {},
}) {
  const hasRedesign = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings.uxRedesignPt1'));
  const originalContainerStyle = {
    height: 'inherit',
    maxHeight: 'none',
    overflowY: 'visible',
  };
  const redesignedContainerStyle = {
    height: 'auto',
    maxHeight: 'calc(100vh - 250px)',
    overflowY: 'auto',
  };

  return (
    <div style={{ padding: 10, ...style}} ref={onRef}>
      <Row justify='space-between' align='middle' style={{ maxWidth: 500, width: '100%' }}>
        <Col>
          <DisplayText title={title} style={{
            fontSize: 16,
            marginBottom: 20,
            marginTop: 20,
            color: Colors.ONTRACCR_GRAY
          }}/>
        </Col>
        <Col>
          {leftHeaderView}
        </Col>
      </Row>

      <BorderedComponent
        containerStyle={{
          ...(hasRedesign ? redesignedContainerStyle : originalContainerStyle),
          ...containerStyle,
        }}
        style={{
          width: 500,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 20,
          paddingRight: 20,
        }}
      >
        {children}
      </BorderedComponent>
    </div>
  );
}
